import { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../auth/AuthProvider'
import { createAppointmentActionsRepository } from '../appointment-actions-repository'
import { createBookingChecksRepository } from '../../booking-checks/booking-checks-repository'
import { createProviderResourceRepository } from '../../settings/provider-resource-repository'
import { createPatientsRepository } from '../../patients/patients-repository'
import { usePatient } from '../../patients/use-patients'
import { useBookingCapability } from '../use-booking-capability'
import type { AppointmentItem } from '../appointments-model'
import { AppointmentDetailModal } from './AppointmentDetailModal'

// Uses the same repositories, patient directory and capability gate as Appointments.
// Mounted only while detail is open from an otherwise read-only surface.
export function ConnectedAppointmentDetailModal(props: {
  appointment: AppointmentItem
  tenantId: string
  nowMs: number
  onClose: () => void
}) {
  const auth = useAuth()
  const user = auth.status === 'authenticated' ? auth.user : null
  const navigate = useNavigate()
  const sources = useMemo(
    () => ({
      actions: createAppointmentActionsRepository({ getUser: () => user }),
      resources: createProviderResourceRepository({ getUser: () => user }),
      patients: createPatientsRepository({ getUser: () => user }),
      bookingChecks: createBookingChecksRepository({ getUser: () => user }),
    }),
    [user]
  )
  const patient = usePatient(
    sources.patients,
    props.tenantId,
    props.appointment.patientAuthorityId ?? ''
  )
  const capability = useBookingCapability(sources.resources, props.tenantId)
  return (
    <AppointmentDetailModal
      {...props}
      actionRepository={sources.actions}
      bookingCapability={capability}
      patients={patient.patient ? [patient.patient] : []}
      bookingChecksRepository={sources.bookingChecks}
      onNavigate={(path) => void navigate(path)}
    />
  )
}
